import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px;
  background: #f5f5f5;
`;

const BrandingSection = styled.div`
  display: flex;
  align-items: center;
  a {
    text-decoration: none;
  }
`;

const Logo = styled.h1`
  font-size: 20px;
  line-height: 20px;
`;
const MenuSection = styled.div`
  margin-left: auto;
`;

const Header = () => {
  return (
    <HeaderContainer>
      <BrandingSection>
        <Link to="/">
          <Logo>React Image Editor</Logo>
        </Link>
      </BrandingSection>

      <MenuSection>
        <Link to="/">About</Link>
      </MenuSection>
    </HeaderContainer>
  );
};

export default Header;
